import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
} from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { IUnidadeSaudePagedResponse } from "models/response/unidade-saude-paged-response";
import { PaginationResponse } from "models/pagination-response";

type UnidadesSaudeTableProps = {
    currentItems: PaginationResponse<IUnidadeSaudePagedResponse>;
};

export const UnidadesSaudeTable: React.FC<UnidadesSaudeTableProps> = ({ currentItems }) => {
    const navigate = useNavigate();

    if (!currentItems?.hasItems()) {
        return <Typography variant="body1">Nenhuma unidade de saúde encontrada.</Typography>;
    }

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Unidade</TableCell>
                        <TableCell>Endereço</TableCell>
                        <TableCell>Horário de Funcionamento</TableCell>
                        <TableCell>Última Atualização</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {currentItems.items.map((item) => (
                        <TableRow
                            key={item.id}
                            hover
                            style={{ cursor: 'pointer' }}
                            onClick={() => navigate(`/unidades-saude/${item.id}`)}
                        >
                            <TableCell>{item.nomeUnidade}</TableCell>
                            <TableCell>{item.desEndereco}</TableCell>
                            <TableCell>{item.desHorarioFuncionamento}</TableCell>
                            <TableCell>{new Date(item.dtaAtualizacao).toLocaleDateString('pt-BR')}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
